module.exports = __webpack_public_path__ + "img/sword-air-04.270905fc.png";